import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminProductsComponent } from './components/admin/admin-products/admin-products.component';
import { HomeComponent } from './components/home/home.component';
import { ProductsComponent } from './components/products/products.component';
import { SearchComponent } from './components/search/search.component';
import { ShowCategoryComponent } from './components/show-category/show-category.component';
import { ShowProductComponent } from './components/show-product/show-product.component';

const routes: Routes = [
  { path:"home" , component: HomeComponent },
  { path:"products" , component: ProductsComponent },
  { path:"products/:category" , component: ShowCategoryComponent },
  { path:"product/:id" , component: ShowProductComponent },
  { path:"search/:value" , component: SearchComponent },
  { path:"admin/products" , component: AdminProductsComponent },
  { path:"**" , redirectTo:"home", pathMatch: "full" }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
